//Imports
import es from 'date-fns/locale/es';
import { Button, Form, Row, Col, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { faCalendarAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { GruposService, VehiculosService } from '../../../services/apiService';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { sortBy } from "underscore";

import { MultiSelect } from 'primereact/multiselect';
import '../../../styles/global.css'
import "primereact/resources/themes/lara-light-blue/theme.css";
import { createRenderCustomHeader } from '../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../utils/datePickerUtils';
import '../../../styles/datepicker.css'

import { locale as primeLocale, addLocale } from 'primereact/api'
import { useFiltrosStore } from "../../../lib/store/filtros.store";

import { jwtDecode } from 'jwt-decode';
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../utils/bitacora';

// Registrar la region en español para DatePicker
registerLocale('es', es);
setDefaultLocale('es');

//Modulo principal React 
const FormFilters = ({ onGenerateReport, imprimir }) => {

    const [grupos, setGrupos] = useState([]);
    const [selectedGrupo, setSelectedGrupo] = useState(null);

    const vehiculos = useFiltrosStore((state) => state.vehiculos)
    const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
    const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
    const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)

    // states
    //const [vehiculos, setVehiculos] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState([]);

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);
    const [dateRangeWarning, setDateRangeWarning] = useState("");
    const [dateRangeInvalid, setDateRangeInvalid] = useState(false);
    // Validar rango de fechas: máximo 31 días
    useEffect(() => {
        if (!startDate || !endDate) return;
        const diffMs = endDate - startDate;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        if (diffDays > 31) {
            setDateRangeWarning("El rango máximo permitido es de 31 días.");
            setDateRangeInvalid(true);
            // import('sweetalert2').then(Swal => {
            //     Swal.default.fire({
            //         icon: 'warning',
            //         title: 'Rango de fechas inválido',
            //         text: 'El rango máximo permitido es de 5 días.',
            //     });
            // });
        } else {
            setDateRangeWarning("");
            setDateRangeInvalid(false);
        }
    }, [startDate, endDate]);

    const [kilometersIni, setKilometersIni] = useState('');
    const [kilometersEnd, setKilometersEnd] = useState('');

    //Estilo de los time pickers
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    // Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    const handleClickFilter = () => {

        // Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
        /*const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
        const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
        const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC*/

        const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
        const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")
        generarBitacoraReporte(AccionBitacora.Generar);
        const decoded = jwtDecode(localStorage.getItem('token'));
        onGenerateReport({
            // Campos básicos de fecha y vehículos (nota el singular en uids_vehiculo)
            fecha_inicio: _fechaInicio,
            fecha_fin: _fechaFin,
            uids_vehiculo: selectedVehicle && selectedVehicle.length > 0
                ? selectedVehicle.map(v => v)
                : [],

            // Campos específicos del reporte de kilometraje
            distancia_1: kilometersIni || 0,
            distancia_2: kilometersEnd || 0,

            // Campos adicionales requeridos por la API
            empresaUid: decoded.uid_empresa,
            page: 1,
            limit: 10000,
            uid_usuario: decoded.uid_usuario,
            perfil: 1,
            count: true,
            order: 1,

            // Campos opcionales que puedes mantener
            tipo: "Todo",
            recalculo_geocercas: false,
            vehiculos: vehiculos.filter(w => selectedVehicle.includes(w.value)),
        });

    };

    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Kilometros', observacion: 'Kilometros', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = (grupos || []).filter(w => (selectedGrupo || []).includes(w.value));
            let dataVehiculos = (vehiculos || []).filter(w => (selectedVehicle || []).includes(w.value));
            let dataAlertas = [];
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
        }
        guardarBitacora({
            categoria: 'Reporte Kilometros',
            observacion: generarObservacion(
                'Kilometros',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                }
            ),
            tipoAccion: accion
        });
    }
    const handleFieldChangeIni = (e) => {
        const { value } = e.target;
        setKilometersIni(value);
    };

    const handleFieldChangeEnd = (e) => {
        const { value } = e.target;
        setKilometersEnd(value);
    };

    // Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {

        const allSelected = selected.some(option => option.value === 'all');
        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) {
                // Se suma 1 por la opción "Seleccionar todos"
                // Deseleccionar todo correctamente
                setSelected([]);
            } else {
                // Seleccionar todas las opciones
                // Ignorando los agrupadores
                setSelected(todasLasOpciones);
            }
        } else {
            setSelected(selected);
        }
    };

    const loadGrupos = async () => {
        try {
            const response = await GruposService.getGrupos();
            if (response && response.statusCode === 200) {

                const _grupos = sortBy(response.data, 'nombre')

                const gruposData = _grupos.map((grupo) => ({
                    value: grupo.uid_grupo,
                    label: `${grupo.nombre}`,
                    uid_grupo: grupo.uid_grupo
                }));

                //setSelectedGrupo(gruposData)
                setGrupos(gruposData);
            }
        } catch (error) {
            console.error("Error cargando los grupos:", error);
        }
    };

    const loadVehiculos = async () => {
        try {
            const response = await VehiculosService.getVehiculos();

            if (response && response.statusCode === 200) {
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

                const vehiculosData = _vehiculos.map(vehiculo => ({
                    value: vehiculo.uid_vehiculo ?? "",
                    label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                    uid_grupo: vehiculo.uid_grupo ?? "",
                    no_economico: vehiculo.no_economico ?? "",
                    alias: `${vehiculo.alias ?? ""}`,
                    tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
                    color_vehiculo: (vehiculo?.color_vehiculo || 'black').toLocaleLowerCase().replace('white', '#e8e8e8').replace('#ffffff', '#e8e8e8')
                }));
                setVehiculos(vehiculosData);
                setVehiculosFiltrados([]);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);
    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );


    // Obtiene los Vehículos
    // const loadVehiculos = async () => {
    //     try {
    //         //Servicio vehiculos 
    //         const response = await VehiculosService.getVehiculos();

    //         //Valida los datos obtenidos
    //         if (response && response.statusCode === 200) {

    //             const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

    //             //listado de imputs para el select
    //             const vehiculosData = _vehiculos.map(vehiculo => ({
    //                 value: vehiculo.uid_vehiculo,
    //                 label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
    //                 uid_grupo: vehiculo.uid_grupo,
    //                 no_economico: vehiculo.no_economico,
    //                 alias: `${vehiculo.alias}`,
    //                 color_vehiculo: (vehiculo?.color_vehiculo || 'black').toLocaleLowerCase().replace('white', '#e8e8e8').replace('#ffffff', '#e8e8e8')
    //             }));

    //             //llena los vehiculos
    //             setVehiculos(vehiculosData);
    //             setVehiculosFiltrados([])
    //         }
    //     } catch (error) {
    //         console.error("Error cargando vehículos:", error);
    //     }
    // };

    //Inicializa la vista
    useEffect(() => {
        loadGrupos()
        loadVehiculos()
    }, []);

    useEffect(() => {

        setVehiculosFiltrados(selectedGrupo || [])
    }, [selectedGrupo]);

    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    //Retorna el componente principal
    return (
        <>

            <Row className='mb-3'>

                {dateRangeWarning && (
                    <Col xs={12}>
                        <div className="alert alert-warning py-2 my-2">
                            {dateRangeWarning}
                        </div>
                    </Col>
                )}


                <Col md={3} xs={4} className=' mb-2'>
                    <Form.Group>
                        <Form.Label>Desde</Form.Label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChangeWrapper}
                            customInput={<ExampleCustomInput />}
                            timeIntervals={5}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            /* showTimeSelect */
                            renderCustomHeader={renderIniHeader}
                            popperClassName="custom-datepicker-popper"
                            fixedHeight
                            locale="es"
                            timeCaption="Hora"
                            maxDate={new Date()}
                            minTime={new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)}
                            maxTime={(() => {
                                const today = new Date();
                                const isToday = startDate.getDate() === today.getDate() && startDate.getMonth() === today.getMonth() && startDate.getFullYear() === today.getFullYear();
                                return isToday ? today : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59);
                            })()}
                        />
                    </Form.Group>
                </Col>

                <Col md={3} xs={4} className='mb-2'>
                    <Form.Group>
                        <Form.Label>Hasta</Form.Label>
                        <DatePicker
                            selected={endDate}
                            minDate={startDate}
                            minTime={
                                endDate.getDate() === startDate.getDate()
                                    ? startDate
                                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                            }
                            maxTime={(() => {
                                const today = new Date();
                                const isToday = endDate.getDate() === today.getDate() && endDate.getMonth() === today.getMonth() && endDate.getFullYear() === today.getFullYear();
                                return isToday ? today : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59);
                            })()}
                            onChange={handleEndDateChangeWrapper}
                            customInput={<ExampleCustomInput />}
                            timeIntervals={5}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            /* showTimeSelect */
                            renderCustomHeader={renderEndHeader}
                            popperClassName="custom-datepicker-popper"
                            fixedHeight
                            locale="es"
                            timeCaption="Hora"
                            maxDate={new Date()}
                        />
                    </Form.Group>
                </Col>

                <Col md={3} xs={4} className="d-flex flex-column mb-2">
                    <Form.Label>Grupo</Form.Label>
                    <MultiSelect
                        className="multiselect-ul w-full md:w-20rem"
                        value={selectedGrupo}
                        onChange={(e) => {
                            setSelectedGrupo(e.value);
                            setSelectedVehicle([]);
                        }}
                        options={grupos}
                        optionLabel="label"
                        filter
                        placeholder="Seleccione un grupo"
                        maxSelectedLabels={2}
                        selectedItemsLabel={`${(selectedGrupo || []).length} grupos seleccionados`}
                    />
                </Col>
                <Col md={3} xs={4} className="d-flex flex-column mb-2">
                    <Form.Label>Vehículos</Form.Label>
                    <MultiSelect
                        className="multiselect-ul w-full md:w-20rem"
                        value={selectedVehicle}
                        onChange={(e) => {
                            setSelectedVehicle(e.value)
                        }}
                        options={vehiculosFiltrado}
                        optionLabel="label"
                        filter
                        placeholder="Seleccione un vehículo"
                        maxSelectedLabels={2}
                        selectedItemsLabel={`${(selectedVehicle || []).length} vehículos seleccionados`}
                    />
                </Col>

                {/**
                 * <Col md={8} xs={4}>
                    <Form.Group>
                        <Form.Label>Seleccionar Vehículos</Form.Label>
                        <Select
                            closeMenuOnSelect={false}
                            options={[
                                ...(selectedVehicle.length !== vehiculos.length
                                    ? [{ value: 'all', label: 'Seleccionar todos' }]
                                    : [{ value: 'all', label: 'Deseleccionar todos' }]
                                ),
                                ...vehiculos
                            ]}
                            classNamePrefix="react-select"
                            value={selectedVehicle}
                            onChange={(selected) => handleSelectChange(selected, vehiculos, setSelectedVehicle)}
                            isMulti
                            styles={customStyles}
                        />
                    </Form.Group>
                </Col>
                 */}

                <Col md={3} xs={4} >
                    <Form.Group>
                        <Form.Label style={style1Lines} title='Distancia Recorrida (KM)'>Distancia Recorrida (KM)</Form.Label>
                        <Form.Control
                            value={kilometersIni}
                            placeholder="0 KM"
                            name="distancia_recorrida"
                            type="number"
                            onChange={handleFieldChangeIni}
                        />
                    </Form.Group>
                </Col>

                <Col md={3} xs={4} >
                    <Form.Group>
                        <Form.Label> </Form.Label>

                        <Form.Control
                            value={kilometersEnd}
                            className='mt-1'
                            placeholder="200 KM"
                            name="distancia_recorrida_fin"
                            type="number"
                            onChange={handleFieldChangeEnd}
                        />
                    </Form.Group>
                </Col>

                <Col md={2} xs={4}>
                    <div className="d-flex justify-content-center mt-4">
                        <Button variant="primary" className="w-100" onClick={handleClickFilter} disabled={!(selectedVehicle.length > 0) || dateRangeInvalid}>
                            Generar
                        </Button>
                        {/* {dateRangeWarning && (
                            <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>{dateRangeWarning}</div>
                        )} */}
                    </div>
                </Col>
                <Col md={2} xs={4}>
                    <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                    </div>
                </Col>

            </Row>
        </>

    )
}

export default FormFilters;